import _ from 'underscore'
import Backbone from 'backbone'
import ImageView from './image-view'
import Core from '../core'

class ListImagesView extends Backbone.View {
    async initialize () {
        this.name = 'LazyLoadingImages'

        Core.Modules.set(this)

        this.setElement('picture')

        Core.Status.update('lazyloading-images', 'status', 'finished')

        this.render()
    }

    render () {
        _.each(this.$el, (obj) => {
            new ImageView({
                el: obj
            })
        })

        // Checa todos os elementos que já estão na página
        Core.Tasks.add(() => {
            Core.Lazyloading.checkAll()
        })
    }

    add ($el) {
        _.each($el, (obj) => {
            new ImageView({
                el: obj
            })
        })

        Core.Tasks.add(() => {
            Core.Lazyloading.checkAll()
        })
    }
}

export default ListImagesView
